import React from 'react';
import { PRODUCT_IMAGES } from '../../../../branding/assets';

const SidebarSmart = ({ tab, setTab }) => {
  const items = [
    //{ key: 'nova', label: 'Criar Campanha' },
    { key: 'campanhas', label: 'Campanhas' },
    { key: 'segmentacoes', label: 'Segmentações' },
    { key: 'nova-segmentacao', label: 'Nova Segmentação', hidden: true },
    //{ key: 'resultados', label: 'Resultados' },
  ];

  return (
    <div
      style={{
        width: '240px',
        backgroundColor: '#FF5E00',
        borderRight: '4px solid #000',
        boxShadow: '6px 0 0 #000',
        padding: '2rem 1rem',
        fontFamily: 'monospace',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: '100vh',
      }}
    >
      <div
        style={{
          padding: '1rem',
          marginBottom: '2rem',
        }}
      >
        <img
          src={PRODUCT_IMAGES.smartCampaigns}
          alt="Smart Campaigns"
          style={{
            height: '110px',
            display: 'block',
            objectFit: 'contain',
          }}
        />
      </div>

      {items
        .filter((item) => !item.hidden)
        .map((item) => (
          <div
            key={item.key}
            onClick={() => setTab(item.key)}
            style={{
              marginBottom: '1rem',
              padding: '0.75rem 1rem',
              backgroundColor: tab === item.key ? '#000' : '#fff',
              color: tab === item.key ? '#fff' : '#000',
              fontWeight: 'bold',
              border: '3px solid #000',
              cursor: 'pointer',
              boxShadow: tab === item.key ? '4px 4px 0 #000' : '2px 2px 0 #000',
              width: '100%',
              textAlign: 'center',
              transition: '0.2s all',
            }}
          >
            {item.label}
          </div>
        ))}
    </div>
  );
};

export default SidebarSmart;

